package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings3 {
  internal val handle_god_names: StringResource by lazy { init_handle_god_names() }

  internal val hebrew_aleph_bet: StringResource by lazy { init_hebrew_aleph_bet() }

  internal val hebrew_app_name: StringResource by lazy { init_hebrew_app_name() }

  internal val hebrew_browse: StringResource by lazy { init_hebrew_browse() }

  internal val hebrew_chapter_content: StringResource by lazy { init_hebrew_chapter_content() }

  internal val hebrew_complete_chapter: StringResource by lazy { init_hebrew_complete_chapter() }

  internal val hebrew_complete_verse: StringResource by lazy { init_hebrew_complete_verse() }

  internal val hebrew_mikud: StringResource by lazy { init_hebrew_mikud() }

  internal val hebrew_misc: StringResource by lazy { init_hebrew_misc() }

  internal val hebrew_multiple_choice_questions: StringResource by lazy {
      init_hebrew_multiple_choice_questions() }

  internal val hebrew_names_in_bible: StringResource by lazy { init_hebrew_names_in_bible() }

  internal val hebrew_open_questions: StringResource by lazy { init_hebrew_open_questions() }

  internal val hebrew_pair_matching: StringResource by lazy { init_hebrew_pair_matching() }

  internal val hebrew_personal_list: StringResource by lazy { init_hebrew_personal_list() }

  internal val hebrew_purchase: StringResource by lazy { init_hebrew_purchase() }

  internal val hebrew_pyramid_crossword: StringResource by lazy { init_hebrew_pyramid_crossword() }

  internal val hebrew_random_verse: StringResource by lazy { init_hebrew_random_verse() }

  internal val hebrew_search_in_bible: StringResource by lazy { init_hebrew_search_in_bible() }

  internal val hebrew_title_activity_settings: StringResource by lazy {
      init_hebrew_title_activity_settings() }

  internal val hebrew_winners_list: StringResource by lazy { init_hebrew_winners_list() }

  internal val help: StringResource by lazy { init_help() }

  internal val help_main_activity: StringResource by lazy { init_help_main_activity() }

  internal val hide: StringResource by lazy { init_hide() }

  internal val hide_nikud: StringResource by lazy { init_hide_nikud() }

  internal val hide_people_names: StringResource by lazy { init_hide_people_names() }

  internal val hide_title_bar_on_scroll: StringResource by lazy { init_hide_title_bar_on_scroll() }

  internal val highlights_with_asterisks: StringResource by lazy { init_highlights_with_asterisks()
      }

  internal val highlights_with_brackets: StringResource by lazy { init_highlights_with_brackets() }

  internal val how_many_words_to_hide: StringResource by lazy { init_how_many_words_to_hide() }

  internal val how_to_save_search_results_highlights: StringResource by lazy {
      init_how_to_save_search_results_highlights() }

  internal val how_to_search: StringResource by lazy { init_how_to_search() }

  internal val how_to_upgrade: StringResource by lazy { init_how_to_upgrade() }

  internal val illegal_name_to_be_searched: StringResource by lazy {
      init_illegal_name_to_be_searched() }

  internal val illegal_regular_expression: StringResource by lazy {
      init_illegal_regular_expression() }

  internal val include_book_and_chapter: StringResource by lazy { init_include_book_and_chapter() }

  internal val include_book_name: StringResource by lazy { init_include_book_name() }

  internal val include_chapter_letter: StringResource by lazy { init_include_chapter_letter() }

  internal val increase_text_size: StringResource by lazy { init_increase_text_size() }

  internal val instruction_pair: StringResource by lazy { init_instruction_pair() }

  internal val interesting_fact1: StringResource by lazy { init_interesting_fact1() }

  internal val interesting_fact10: StringResource by lazy { init_interesting_fact10() }

  internal val interesting_fact11: StringResource by lazy { init_interesting_fact11() }

  internal val interesting_fact12: StringResource by lazy { init_interesting_fact12() }

  internal val interesting_fact2: StringResource by lazy { init_interesting_fact2() }

  internal val interesting_fact3: StringResource by lazy { init_interesting_fact3() }

  internal val interesting_fact4: StringResource by lazy { init_interesting_fact4() }

  internal val interesting_fact5: StringResource by lazy { init_interesting_fact5() }

  internal val interesting_fact5a: StringResource by lazy { init_interesting_fact5a() }

  internal val interesting_fact5b: StringResource by lazy { init_interesting_fact5b() }

  internal val interesting_fact6: StringResource by lazy { init_interesting_fact6() }

  internal fun values(): List<StringResource> = listOf(handle_god_names, hebrew_aleph_bet,
      hebrew_app_name, hebrew_browse, hebrew_chapter_content, hebrew_complete_chapter,
      hebrew_complete_verse, hebrew_mikud, hebrew_misc, hebrew_multiple_choice_questions,
      hebrew_names_in_bible, hebrew_open_questions, hebrew_pair_matching, hebrew_personal_list,
      hebrew_purchase, hebrew_pyramid_crossword, hebrew_random_verse, hebrew_search_in_bible,
      hebrew_title_activity_settings, hebrew_winners_list, help, help_main_activity, hide,
      hide_nikud, hide_people_names, hide_title_bar_on_scroll, highlights_with_asterisks,
      highlights_with_brackets, how_many_words_to_hide, how_to_save_search_results_highlights,
      how_to_search, how_to_upgrade, illegal_name_to_be_searched, illegal_regular_expression,
      include_book_and_chapter, include_book_name, include_chapter_letter, increase_text_size,
      instruction_pair, interesting_fact1, interesting_fact10, interesting_fact11,
      interesting_fact12, interesting_fact2, interesting_fact3, interesting_fact4,
      interesting_fact5, interesting_fact5a, interesting_fact5b, interesting_fact6)
}

private fun init_handle_god_names(): StringResource = StringResource(key = "handle_god_names",
    loader = stringsLoader)

private fun init_hebrew_aleph_bet(): StringResource = StringResource(key = "hebrew_aleph_bet",
    loader = stringsLoader)

private fun init_hebrew_app_name(): StringResource = StringResource(key = "hebrew_app_name", loader
    = stringsLoader)

private fun init_hebrew_browse(): StringResource = StringResource(key = "hebrew_browse", loader =
    stringsLoader)

private fun init_hebrew_chapter_content(): StringResource = StringResource(key =
    "hebrew_chapter_content", loader = stringsLoader)

private fun init_hebrew_complete_chapter(): StringResource = StringResource(key =
    "hebrew_complete_chapter", loader = stringsLoader)

private fun init_hebrew_complete_verse(): StringResource = StringResource(key =
    "hebrew_complete_verse", loader = stringsLoader)

private fun init_hebrew_mikud(): StringResource = StringResource(key = "hebrew_mikud", loader =
    stringsLoader)

private fun init_hebrew_misc(): StringResource = StringResource(key = "hebrew_misc", loader =
    stringsLoader)

private fun init_hebrew_multiple_choice_questions(): StringResource = StringResource(key =
    "hebrew_multiple_choice_questions", loader = stringsLoader)

private fun init_hebrew_names_in_bible(): StringResource = StringResource(key =
    "hebrew_names_in_bible", loader = stringsLoader)

private fun init_hebrew_open_questions(): StringResource = StringResource(key =
    "hebrew_open_questions", loader = stringsLoader)

private fun init_hebrew_pair_matching(): StringResource = StringResource(key =
    "hebrew_pair_matching", loader = stringsLoader)

private fun init_hebrew_personal_list(): StringResource = StringResource(key =
    "hebrew_personal_list", loader = stringsLoader)

private fun init_hebrew_purchase(): StringResource = StringResource(key = "hebrew_purchase", loader
    = stringsLoader)

private fun init_hebrew_pyramid_crossword(): StringResource = StringResource(key =
    "hebrew_pyramid_crossword", loader = stringsLoader)

private fun init_hebrew_random_verse(): StringResource = StringResource(key = "hebrew_random_verse",
    loader = stringsLoader)

private fun init_hebrew_search_in_bible(): StringResource = StringResource(key =
    "hebrew_search_in_bible", loader = stringsLoader)

private fun init_hebrew_title_activity_settings(): StringResource = StringResource(key =
    "hebrew_title_activity_settings", loader = stringsLoader)

private fun init_hebrew_winners_list(): StringResource = StringResource(key = "hebrew_winners_list",
    loader = stringsLoader)

private fun init_help(): StringResource = StringResource(key = "help", loader = stringsLoader)

private fun init_help_main_activity(): StringResource = StringResource(key = "help_main_activity",
    loader = stringsLoader)

private fun init_hide(): StringResource = StringResource(key = "hide", loader = stringsLoader)

private fun init_hide_nikud(): StringResource = StringResource(key = "hide_nikud", loader =
    stringsLoader)

private fun init_hide_people_names(): StringResource = StringResource(key = "hide_people_names",
    loader = stringsLoader)

private fun init_hide_title_bar_on_scroll(): StringResource = StringResource(key =
    "hide_title_bar_on_scroll", loader = stringsLoader)

private fun init_highlights_with_asterisks(): StringResource = StringResource(key =
    "highlights_with_asterisks", loader = stringsLoader)

private fun init_highlights_with_brackets(): StringResource = StringResource(key =
    "highlights_with_brackets", loader = stringsLoader)

private fun init_how_many_words_to_hide(): StringResource = StringResource(key =
    "how_many_words_to_hide", loader = stringsLoader)

private fun init_how_to_save_search_results_highlights(): StringResource = StringResource(key =
    "how_to_save_search_results_highlights", loader = stringsLoader)

private fun init_how_to_search(): StringResource = StringResource(key = "how_to_search", loader =
    stringsLoader)

private fun init_how_to_upgrade(): StringResource = StringResource(key = "how_to_upgrade", loader =
    stringsLoader)

private fun init_illegal_name_to_be_searched(): StringResource = StringResource(key =
    "illegal_name_to_be_searched", loader = stringsLoader)

private fun init_illegal_regular_expression(): StringResource = StringResource(key =
    "illegal_regular_expression", loader = stringsLoader)

private fun init_include_book_and_chapter(): StringResource = StringResource(key =
    "include_book_and_chapter", loader = stringsLoader)

private fun init_include_book_name(): StringResource = StringResource(key = "include_book_name",
    loader = stringsLoader)

private fun init_include_chapter_letter(): StringResource = StringResource(key =
    "include_chapter_letter", loader = stringsLoader)

private fun init_increase_text_size(): StringResource = StringResource(key = "increase_text_size",
    loader = stringsLoader)

private fun init_instruction_pair(): StringResource = StringResource(key = "instruction_pair",
    loader = stringsLoader)

private fun init_interesting_fact1(): StringResource = StringResource(key = "interesting_fact1",
    loader = stringsLoader)

private fun init_interesting_fact10(): StringResource = StringResource(key = "interesting_fact10",
    loader = stringsLoader)

private fun init_interesting_fact11(): StringResource = StringResource(key = "interesting_fact11",
    loader = stringsLoader)

private fun init_interesting_fact12(): StringResource = StringResource(key = "interesting_fact12",
    loader = stringsLoader)

private fun init_interesting_fact2(): StringResource = StringResource(key = "interesting_fact2",
    loader = stringsLoader)

private fun init_interesting_fact3(): StringResource = StringResource(key = "interesting_fact3",
    loader = stringsLoader)

private fun init_interesting_fact4(): StringResource = StringResource(key = "interesting_fact4",
    loader = stringsLoader)

private fun init_interesting_fact5(): StringResource = StringResource(key = "interesting_fact5",
    loader = stringsLoader)

private fun init_interesting_fact5a(): StringResource = StringResource(key = "interesting_fact5a",
    loader = stringsLoader)

private fun init_interesting_fact5b(): StringResource = StringResource(key = "interesting_fact5b",
    loader = stringsLoader)

private fun init_interesting_fact6(): StringResource = StringResource(key = "interesting_fact6",
    loader = stringsLoader)

public actual val SharedRes.strings.handle_god_names: StringResource
  get() = CommonMainStrings3.handle_god_names

public actual val SharedRes.strings.hebrew_aleph_bet: StringResource
  get() = CommonMainStrings3.hebrew_aleph_bet

public actual val SharedRes.strings.hebrew_app_name: StringResource
  get() = CommonMainStrings3.hebrew_app_name

public actual val SharedRes.strings.hebrew_browse: StringResource
  get() = CommonMainStrings3.hebrew_browse

public actual val SharedRes.strings.hebrew_chapter_content: StringResource
  get() = CommonMainStrings3.hebrew_chapter_content

public actual val SharedRes.strings.hebrew_complete_chapter: StringResource
  get() = CommonMainStrings3.hebrew_complete_chapter

public actual val SharedRes.strings.hebrew_complete_verse: StringResource
  get() = CommonMainStrings3.hebrew_complete_verse

public actual val SharedRes.strings.hebrew_mikud: StringResource
  get() = CommonMainStrings3.hebrew_mikud

public actual val SharedRes.strings.hebrew_misc: StringResource
  get() = CommonMainStrings3.hebrew_misc

public actual val SharedRes.strings.hebrew_multiple_choice_questions: StringResource
  get() = CommonMainStrings3.hebrew_multiple_choice_questions

public actual val SharedRes.strings.hebrew_names_in_bible: StringResource
  get() = CommonMainStrings3.hebrew_names_in_bible

public actual val SharedRes.strings.hebrew_open_questions: StringResource
  get() = CommonMainStrings3.hebrew_open_questions

public actual val SharedRes.strings.hebrew_pair_matching: StringResource
  get() = CommonMainStrings3.hebrew_pair_matching

public actual val SharedRes.strings.hebrew_personal_list: StringResource
  get() = CommonMainStrings3.hebrew_personal_list

public actual val SharedRes.strings.hebrew_purchase: StringResource
  get() = CommonMainStrings3.hebrew_purchase

public actual val SharedRes.strings.hebrew_pyramid_crossword: StringResource
  get() = CommonMainStrings3.hebrew_pyramid_crossword

public actual val SharedRes.strings.hebrew_random_verse: StringResource
  get() = CommonMainStrings3.hebrew_random_verse

public actual val SharedRes.strings.hebrew_search_in_bible: StringResource
  get() = CommonMainStrings3.hebrew_search_in_bible

public actual val SharedRes.strings.hebrew_title_activity_settings: StringResource
  get() = CommonMainStrings3.hebrew_title_activity_settings

public actual val SharedRes.strings.hebrew_winners_list: StringResource
  get() = CommonMainStrings3.hebrew_winners_list

public actual val SharedRes.strings.help: StringResource
  get() = CommonMainStrings3.help

public actual val SharedRes.strings.help_main_activity: StringResource
  get() = CommonMainStrings3.help_main_activity

public actual val SharedRes.strings.hide: StringResource
  get() = CommonMainStrings3.hide

public actual val SharedRes.strings.hide_nikud: StringResource
  get() = CommonMainStrings3.hide_nikud

public actual val SharedRes.strings.hide_people_names: StringResource
  get() = CommonMainStrings3.hide_people_names

public actual val SharedRes.strings.hide_title_bar_on_scroll: StringResource
  get() = CommonMainStrings3.hide_title_bar_on_scroll

public actual val SharedRes.strings.highlights_with_asterisks: StringResource
  get() = CommonMainStrings3.highlights_with_asterisks

public actual val SharedRes.strings.highlights_with_brackets: StringResource
  get() = CommonMainStrings3.highlights_with_brackets

public actual val SharedRes.strings.how_many_words_to_hide: StringResource
  get() = CommonMainStrings3.how_many_words_to_hide

public actual val SharedRes.strings.how_to_save_search_results_highlights: StringResource
  get() = CommonMainStrings3.how_to_save_search_results_highlights

public actual val SharedRes.strings.how_to_search: StringResource
  get() = CommonMainStrings3.how_to_search

public actual val SharedRes.strings.how_to_upgrade: StringResource
  get() = CommonMainStrings3.how_to_upgrade

public actual val SharedRes.strings.illegal_name_to_be_searched: StringResource
  get() = CommonMainStrings3.illegal_name_to_be_searched

public actual val SharedRes.strings.illegal_regular_expression: StringResource
  get() = CommonMainStrings3.illegal_regular_expression

public actual val SharedRes.strings.include_book_and_chapter: StringResource
  get() = CommonMainStrings3.include_book_and_chapter

public actual val SharedRes.strings.include_book_name: StringResource
  get() = CommonMainStrings3.include_book_name

public actual val SharedRes.strings.include_chapter_letter: StringResource
  get() = CommonMainStrings3.include_chapter_letter

public actual val SharedRes.strings.increase_text_size: StringResource
  get() = CommonMainStrings3.increase_text_size

public actual val SharedRes.strings.instruction_pair: StringResource
  get() = CommonMainStrings3.instruction_pair

public actual val SharedRes.strings.interesting_fact1: StringResource
  get() = CommonMainStrings3.interesting_fact1

public actual val SharedRes.strings.interesting_fact10: StringResource
  get() = CommonMainStrings3.interesting_fact10

public actual val SharedRes.strings.interesting_fact11: StringResource
  get() = CommonMainStrings3.interesting_fact11

public actual val SharedRes.strings.interesting_fact12: StringResource
  get() = CommonMainStrings3.interesting_fact12

public actual val SharedRes.strings.interesting_fact2: StringResource
  get() = CommonMainStrings3.interesting_fact2

public actual val SharedRes.strings.interesting_fact3: StringResource
  get() = CommonMainStrings3.interesting_fact3

public actual val SharedRes.strings.interesting_fact4: StringResource
  get() = CommonMainStrings3.interesting_fact4

public actual val SharedRes.strings.interesting_fact5: StringResource
  get() = CommonMainStrings3.interesting_fact5

public actual val SharedRes.strings.interesting_fact5a: StringResource
  get() = CommonMainStrings3.interesting_fact5a

public actual val SharedRes.strings.interesting_fact5b: StringResource
  get() = CommonMainStrings3.interesting_fact5b

public actual val SharedRes.strings.interesting_fact6: StringResource
  get() = CommonMainStrings3.interesting_fact6
